module.exports = __webpack_public_path__ + "img/GreenCircleCheckmark.16a5dfd7.svg";